import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { DatePicker, ErrorCommon, SelectField, TextFieldCommon } from "../../../../../components/formikFormInputs";
import { useFormikContext } from "formik";
import { Label } from "../../../../../components/formInputs";
import { asDbDateFormat, DATE_FORMAT_DOB_SAVE, isValidDate } from "../../../../../utils/dateUtils";
import moment from "moment";


const GreenCardAndVisaExpiry = (props: any) => {
    const {type, required = true} = props;
    const [expiryDate, setExpiryDate] = React.useState<any>(null);
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue
    } = useFormikContext<any>();

    const f:any = [{
            label: <Label label={"Expiry Date"} required={true} />,
            isRequired: true,
            placeholder: "Expiry Date",
            component: DatePicker,
            disablePast: true,
            className: "fullWidthcustomFields",
            field: { value: expiryDate },
            errMsg:type === "PR" ? "greenCardExpiryMonth" : type === "VISA_PLAN" ? "visaExpiryMonth" : "",
            defaultDateFormat: "MM/dd/yy",
            cb: async (val: any) => {
                if (val) {
                    setExpiryDate(val);
                    const dob: any = asDbDateFormat(val, DATE_FORMAT_DOB_SAVE);
                    const year = moment(dob, DATE_FORMAT_DOB_SAVE).year()
                    const month = moment(dob, DATE_FORMAT_DOB_SAVE).month()

                    if(type === "PR") {
                        setFieldValue("greenCardExpiryMonth", (Number(month)+1))
                        setFieldValue("greenCardExpiryYear", year)
                    }
                    if(type === "VISA_PLAN") {
                        setFieldValue("visaExpiryMonth", (Number(month)+1))
                        setFieldValue("visaExpiryYear", year)
                    }
                }
            }
    }]

    return (
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="body1" className="mb0 w100 floatLeft"> Expiry
                            Date </Typography>
                    </Grid>
                    {(type === "PR" || type === "VISA_PLAN") && f.map((field, index) => {
                        return (
                                <>
                                    <Grid item xs={12} key={index}>
                                        <TextFieldCommon
                                                {...field}
                                                values={values}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                required
                                        />
                                        <ErrorCommon errors={errors} name={field.errMsg || field.name} touched={touched} />
                                    </Grid>
                                </>
                        );
                    })
                    }
            </Grid>
    );
};

export default GreenCardAndVisaExpiry;